var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from "mobx";
export var ContactType;
(function (ContactType) {
    ContactType["Letrwing"] = "Letrwing";
    ContactType["Internal"] = "Internal";
    ContactType["External"] = "External";
    ContactType["App"] = "App";
})(ContactType || (ContactType = {}));
export class UserProfileUIStore {
    constructor() {
        this.loading = false;
        this.showpassword = false;
        this.contactType = ContactType.Internal;
        makeObservable(this);
    }
    setContactType(type) {
        this.contactType = type;
    }
    setShowPassword(show) {
        this.showpassword = show;
    }
    reset() {
        this.setContactType(ContactType.Internal);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UserProfileUIStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserProfileUIStore.prototype, "showpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserProfileUIStore.prototype, "contactType", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserProfileUIStore.prototype, "setContactType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserProfileUIStore.prototype, "setShowPassword", null);
